"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocConversionActionCard = void 0;
var react_1 = __importStar(require("react"));
var BannerActionCard_1 = require("Dashboard/OnboardingBanner/ActionCards/BannerActionCard");
var UseHistoryTypes_1 = require("DataStores/User/UseHistory/UseHistoryTypes");
var inversify_react_1 = require("inversify-react");
var mobx_react_1 = require("mobx-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var ModalComponent_1 = require("@CommonFrontend/Modal/ModalComponent");
var styles = __importStar(require("./DocConversionActionCard.css"));
var CommonUtils_1 = require("@CommonFrontendBackend/Utils/CommonUtils");
var OnboardingBannerTelemetry_1 = __importDefault(require("Dashboard/OnboardingBanner/OnboardingBannerTelemetry"));
exports.DocConversionActionCard = (0, mobx_react_1.observer)(function (_a) {
    var promptId = _a.promptId;
    var cardId = UseHistoryTypes_1.PagesOnboardingBannerAction.DocConversion;
    var promptHistory = (0, inversify_react_1.useInjection)("rootDataStore").userDataStore.useHistoryDataStore
        .inlinePromptsHistoryStore;
    var onboardingBannerTelemetry = (0, inversify_react_1.useInjection)(OnboardingBannerTelemetry_1.default);
    var _b = __read((0, react_1.useState)(false), 2), showTypeFormModal = _b[0], setShowTypeFormModal = _b[1];
    var isCompleted = promptHistory.getCompletedActions(promptId).includes(cardId);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(BannerActionCard_1.BannerActionCard, { key: cardId, label: "Upload Now", isLabelColoured: true, title: "Convert an existing doc into a Qwilr Page", thumbnailUrl: "/Assets/Images/onboarding/dashboard-banner/pages-banner-doc-conversion-action.png", isCompleted: isCompleted, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            onboardingBannerTelemetry.cardClicked(promptId, cardId).catch(function (e) { });
                            setShowTypeFormModal(true);
                            return [4, (0, CommonUtils_1.delay)(3000)];
                        case 1:
                            _a.sent();
                            promptHistory.setActionCompleted(promptId, cardId);
                            return [2];
                    }
                });
            }); } }),
        showTypeFormModal && (react_1.default.createElement(TypeFormModal, { closeModal: function () {
                setShowTypeFormModal(false);
            } }))));
});
var TypeFormModal = function (_a) {
    var closeModal = _a.closeModal;
    var userDataStore = (0, inversify_react_1.useInjection)("rootDataStore").userDataStore;
    return (react_1.default.createElement(ModalComponent_1.Modal, { className: styles.typeFormModal },
        react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.Close, null), size: kaleidoscope_1.ButtonSize.Small, className: styles.closeButton, onClick: closeModal }),
        react_1.default.createElement("div", { className: styles.iframeContainer },
            react_1.default.createElement("iframe", { className: styles.iframe, src: "https://qwilr.typeform.com/to/vOO6HKuD?utm_source=qwilr_product&utm_medium=quick_actions&utm_campaign=doc_upgrade_quick_action&typeform-source=qwilr.com#user_id=".concat(userDataStore.id, "&email=").concat(userDataStore.email, "&mql=xxxxx&lead_owner=xxxxx&source=xxxxx&origin=xxxxx") }))));
};
